import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OccEndpointsService } from '@spartacus/core';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { SITE_CONTEXT_ACTIONS } from '@app-modules/site-context/store/site-context-actions.type';
import { CountryList } from '@app-modules/site-context/types';

import { loadCountriesSuccessAction } from '../actions';

@Injectable()
export class DpLoadCountriesEffect {
  getCountries$;

  readonly #actions$ = inject(Actions);
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpoints = inject(OccEndpointsService);

  constructor() {
    this.getCountries$ = createEffect(() =>
      this.#actions$.pipe(
        ofType(SITE_CONTEXT_ACTIONS.LOAD_COUNTRIES),
        switchMap(() => this.#loadCountries().pipe(map((payload) => loadCountriesSuccessAction({ payload })))),
      ),
    );
  }

  #loadCountries(): Observable<CountryList> {
    const url = this.#occEndpoints.buildUrl('countryList');
    return this.#httpClient.get<CountryList>(url);
  }
}
